import { useEffect } from 'react';
import * as Router from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserState, getLifebooksChildren } from 'redux/selectors';
import { getCurrentChild } from 'services';
import { useMobileListCheck } from 'helpers';
import { useCreateDispatches, useCheckUserPermissions } from 'helpers/hooks';
import { ChildListContainer, Feed, EditPost, Welcome } from 'components';
import VaultActivity from './components/VaultActivity';
import VaultFiles from './components/VaultFiles';
import styles from './vault.module.css';

export function Vault(props) {
	const { childId, feedType } = Router.useParams();
	const { push } = Router.useHistory();
	const {
		basePath = '/vault',
		trustedCaseManagerRoute = false,
	} = props;
	const routeRoot = basePath.replace(/^\/+|\/+$/g, '');

	const { includeUsers, excludeUsers } = useCheckUserPermissions();

	const user = useSelector(getUserState);
	const children = useSelector(getLifebooksChildren);
	const scopedChild = useSelector((state) => state.lifebooks.child);

	const { setRoot } = useCreateDispatches();

	useEffect(() => {
		setRoot('vault');
	}, [setRoot]);

	const selectVaultChild = (e, child) => {
		e.stopPropagation();
		const route = /file/.test(feedType) ? 'files' : 'timeline';
		props.history.push(`${basePath}/${route}/${child.id}`);
	};

	useEffect(() => {
		if (trustedCaseManagerRoute) {
			if (!scopedChild?.id) return;
			if (!childId || childId !== scopedChild.id) {
				push(`${basePath}/timeline/${scopedChild.id}`);
				return;
			}
			getCurrentChild(scopedChild.id);
			return;
		}

		if (excludeUsers('child')) {
			if (childId) {
				getCurrentChild(childId);
			} else if (!childId) {
				push(`${basePath}/`);
			}
		} else {
			getCurrentChild(user.id);
			push(`${basePath}/timeline/${user.id}`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [childId, children, push, user, trustedCaseManagerRoute, scopedChild?.id]);

	useMobileListCheck(!trustedCaseManagerRoute && !childId);

	if (
		trustedCaseManagerRoute &&
		childId &&
		scopedChild?.id &&
		childId !== scopedChild.id
	) {
		return <Router.Redirect to={`${basePath}/timeline/${scopedChild.id}`} />;
	}

	return (
		<div className={styles.vaultContainer}>
			{!trustedCaseManagerRoute && includeUsers('agencyuser', 'csw') && (
				<>
					<ChildListContainer selectChild={selectVaultChild} />
				</>
			)}
			<div className={styles.vaultContent}>
				<div className={styles.vaultFeed}>
					<Router.Switch>
						<Router.Route
							key={childId + feedType}
							path={`${basePath}/post/:childId/:postId?`}>
							<EditPost root='vault' routeRoot={routeRoot} />
						</Router.Route>
						<Router.Route
							key={childId + feedType}
							path={`${basePath}/timeline/:childId`}>
							<Feed routeRoot={routeRoot} />
						</Router.Route>
						<Router.Route
							key={childId + feedType}
							path={`${basePath}/files/:childId/`}>
							<VaultFiles />
						</Router.Route>
						<Router.Route
							key={childId + feedType}
							path={`${basePath}/vaultActivity/:childId/`}>
							<VaultActivity />
						</Router.Route>
						<Router.Route path={`${basePath}/`}>
							<Welcome user={user} />
						</Router.Route>
					</Router.Switch>
				</div>
			</div>
		</div>
	);
}

export default Router.withRouter(Vault);
